import { useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

// Shared hook: fetches districts from Location Master (District-only system).
// `taluksFor` is retained as a no-op stub for legacy callers — always returns [].
export default function useLocations() {
  const [districts, setDistricts] = useState([]);
  const [loading, setLoading] = useState(true);
  const reload = useCallback(() => {
    setLoading(true);
    return api.get("/districts").then(r => setDistricts(r.data)).catch(() => setDistricts([])).finally(() => setLoading(false));
  }, []);
  useEffect(() => { reload(); }, [reload]);
  const taluksFor = () => [];
  return { districts, districtNames: districts.map(d => d.name), taluksFor, loading, reload };
}
